module.exports = __webpack_public_path__ + "img/2022-12.fbda7a53.jpg";